<template>
  <MainLayout selectMenu="4-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Row class="menu-line" type="flex">
        <Col span="12" class="menu-actions"><Button icon="md-add" type="primary" @click.native="add()" size="small">{{
          getTranslation('u002') }}</Button></Col>
      </Row>
      <Affix>
      <Row class="table-header" type="flex">
        <Col flex="1" class="table-cell">{{ getTranslation('m008') }}
        </Col>
        <Col flex="6" class="table-cell">{{ getTranslation('c008') }}
        </Col>
        <Col flex="5" class="table-cell">{{ getTranslation('u003') }}
        </Col>
        <Col flex="3" class="table-cell">{{ getTranslation('u004') }}
        </Col>
        <Col flex="3" class="table-cell">{{ getTranslation('m009') }}
        </Col>
        <Col flex="3" class="table-cell">{{ getTranslation('m017') }}
        </Col>
        <Col flex="4" class="table-cell">{{ getTranslation('m018') }}
        </Col>
      </Row>
      </Affix>
      <Row v-for="(item,index) in user" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
        <Col flex="1" class="table-cell">{{ item.id }}
        </Col>
        <Col flex="6" class="table-cell">{{ item.name }}
        </Col>
        <Col flex="5" class="table-cell">{{ item.nick_name }}
        </Col>
        <Col flex="3" class="table-cell">{{ item.auth }}
        </Col>
        <Col flex="3" class="table-cell">{{ StateMap[item.state] }}
        </Col>
        <Col flex="3" class="table-cell">{{ item.updated_string }}
        </Col>
        <Col flex="4" class="table-cell  action-buttons flex-middle">
        <Button size="small" type="primary" icon="md-create" @click.native="edit(item.id)">{{ getTranslation('m019')
        }}</Button>&nbsp;
        <Button size="small" type="error" icon="md-trash" v-if="item.state != 3" @click.native="del(item.id)">{{
          getTranslation('m027') }}</Button>
        <Button size="small" type="success" icon="md-refresh" v-if="item.state == 3"
          @click.native="recovery(item.id)">{{
            getTranslation('m028') }}</Button>
        </Col>
      </Row>
      <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
        @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
        :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }} {{ getTranslation('c011') }}</Page>
      <UserEdit v-model="modalVisible" :propVisible="modalVisible" :editId="editId" @refresh-page="refreshPage">
      </UserEdit>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const.js'
import axios from 'axios';
import { Page, Row, Col, Button, Affix } from 'view-design';
import UserEdit from './components/UserEdit.vue';
import NoAuth from '@/components/NoAuth.vue'
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'UserIndex', // 组件名称
  computed: {
    ...mapGetters(['getTranslation']),
    StateMap() {
      return {
        0: this.getTranslation("u010"),
        1: this.getTranslation("u011"),
        2: this.getTranslation("u012"),
        3: this.getTranslation("m004")
      };
    },
  },
  components: {
    MainLayout, Page, Row, Col, Button, UserEdit, NoAuth, Affix
  },
  props: {

  },
  data() {
    return {
      user: [],
      total: 0,
      current: 1,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      pageSizeAry: PAGE_SIZE_ARY,
      modalVisible: false,
      editId: 0,
      hasAuth: true
    }
  },
  mounted() {

  },
  created() {
    this.setBreadcrumbItems();
    this.getData();
  },
  methods: {
    getData() {
      let url = API_URL["userGet"];
      let params = {
        page: this.current,
        page_size: this.pageSize
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data.data;
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('u020'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    add() {
      //0代表新增
      this.editId = 0;
      this.modalVisible = true
    },
    edit(id) {
      //0代表新增
      this.editId = id;
      this.modalVisible = true
    },
    del(id) {
      let url = API_URL["userDelete"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(this.getTranslation('u021'));
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    recovery(id) {
      let url = API_URL["userRecover"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(this.getTranslation('u022'));
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    refreshPage() {
      this.getData();
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['u051']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('u051') }
        ])
      }
    }
  },

}
</script>

<style scoped>
@import url("../../assets/style/list.css");
</style>